<!-- #region HTML -->
<template>
    <div class="app">
        <div class="main-container form-container">
            <div>
                <!-- #region Complete Check Image -->
                <img class="complete-check" alt="完了" src="@/assets/img/complete-check.svg" width="100%" />
                <!-- #endregion -->

                <!-- #region Complete Title -->
                <div class="complete-title">アカウントを削除しました</div>
                <!-- #endregion -->

                <!-- #region delete Container -->
                <div class="delete-container flex-center">
                    <div class="description">
                        5秒後にジャンプします。ジャンプしない場合は、<a class="router-link" href="#" @click.prevent="handleManualRedirect">こちら</a>をクリックしてください。
                    </div>
                </div>
                <!-- #endregion delete Container -->
            </div>
        </div>
    </div>
</template>
<!-- #endregion HTML-->
<!-- #region JavaScript -->
<script>
export default {
    name: 'CompleteDeleteAccount',
    data() {
        return {
            redirectTimeout: null,
        };
    },
    mounted() {
        this.redirectTimeout = setTimeout(this.redirectDeletedUser, 5000);
    },
    beforeDestroy() {
        if (this.redirectTimeout) {
            clearTimeout(this.redirectTimeout);
        }
    },
    methods: {
        // redirectDeletedUser()を呼び出すメソッド
        // @click.preventのところで直接redirectDeletedUser()使うと反映されないため、こちらのカバーをつける
        handleManualRedirect() {
            this.redirectDeletedUser();
        },
        // ユーザー情報を削除、'signin'に転送、ページを再読み込み
        redirectDeletedUser() {
            this.$store.commit('clearAuthData');
            this.$router.push({ name: 'signin' });
        }
    }
}
</script>
<!-- #endregion -->